import { Inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { TGBAttributes, TGrowthBookConfig } from '@x/common/ab-test/ab-test.config';
import { AB_TEST_DEVICE_ID_COOKIE_NAME } from '@x/common/ab-test/constants';
import { WindowRef } from '@x/common/browser';
import { TEABTestExperimentViewed } from '@x/common/tracking/event-models/ab-test.events';
import { TrackingService } from '@x/common/tracking/tracking.service';
import { ChannelState } from '@x/ecommerce-shop/app/channel/state';
import { AuthState } from '@x/ecommerce-shop/app/core/auth/state/auth.state';
import { IShopConfig, SHOP_CONFIG } from '@x/ecommerce-shop/config/shop.config';
import Cookies from 'js-cookie';
import { of } from 'rxjs';
import { filter, map } from 'rxjs/operators';

@Injectable()
export class GrowthBookContextService implements TGrowthBookConfig {
  constructor(
    private store: Store,
    private trackingService: TrackingService,
    private router: Router,
    private windowRef: WindowRef,
    @Inject(SHOP_CONFIG) private shopConfig: IShopConfig,
  ) {}

  apiHost = this.shopConfig.abTestConfig?.apiHost;
  clientKey = this.shopConfig.abTestConfig?.clientKey;
  enableDevMode = this.shopConfig.abTestConfig?.enableDevMode;
  flavor = this.shopConfig.flavor;

  attributesToObserve: TGBAttributes = {
    userId: this.store.select(AuthState.loggedInUser).pipe(map((u) => u?.id)),
    channelCode: this.store.select(ChannelState.activeChannelCode),
    url: this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map((event) => event.url),
    ),
    ...(this.windowRef.userAgent && { userAgent: of(this.windowRef.userAgent) }),
  };

  onExperimentViewed = (experimentId: string, variationId: string) => {
    const deviceId = Cookies.get(AB_TEST_DEVICE_ID_COOKIE_NAME);

    this.trackingService.sendEvent(
      new TEABTestExperimentViewed({
        experimentId,
        variationId,
        deviceId,
      }),
    );
  };
}
